import React from 'react';
import DOMPurify from 'dompurify';

const JiraDescription = ({ data }) => {
  const htmlContent = DOMPurify.sanitize(data);

  const containerStyle = {
    maxWidth: '100%',
    overflow: 'hidden',
    wordWrap: 'break-word'
  };

  const imageStyle = `.jira-description-content img { max-width: 100% !important; height: auto !important; }`;

  return (
    <div style={containerStyle}>
      <style dangerouslySetInnerHTML={{ __html: imageStyle }} />
      <div className="jira-description-content" dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
};

export default JiraDescription;
